import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { ExternalLink } from '../../src/components';
import { Box } from '@primer/components';
import Blockquote from '@primer/gatsby-theme-doctocat/src/components/blockquote';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`There are several elements to this "framework":`}</p>
    <ol>
      <li parentName="ol">{`GatsbyJS - Site Generator (uses React)`}</li>
      <li parentName="ol">{`Primer.Doctocat - Theme by GitHub`}</li>
      <li parentName="ol">{`Primer.Components - React Components`}</li>
      <li parentName="ol">{`Primer.StyledOcticons - GitHub Icons (SVG)`}</li>
      <li parentName="ol">{`MDX - Extended Markdown`}</li>
    </ol>
    <h2>{`GatsbyJS`}</h2>
    <p>{`GatsbyJS is a site generator that uses modern web technologies to produce in their words "blazing fast websites and apps".`}</p>
    <p>{`It is based on the React JavaScript framework from Facebook and uses Webpack, GraphQL and the latest development techniques to provide really fast user experiences.`}</p>
    <ExternalLink href="https://gatsbyjs.org" mdxType="ExternalLink">Click here to learn more</ExternalLink>
    <h2>{`Primer`}</h2>
    <p>{`Primer is the design system built by, and for GitHub. It encompasses everything from Iconography and Web Components, through to the companies presentation master slides. We use a small subset of their open-source tools which are detailed below.`}</p>
    <ExternalLink href="https://primer.style" mdxType="ExternalLink">Click here to learn more</ExternalLink>
    <h3>{`Doctocat`}</h3>
    <p>{`Doctocat is the GatsbyJS theme GitHub have developed for their documentation. It is preconfigured for working within the Primer team, so requires some modification out-of-the-box to remove branding etc.`}</p>
    <p>{`It also contains a number of useful components and datasources that link back to GitHub data such as the list of Contributors at the bottom of each page.`}</p>
    <ExternalLink href="https://primer.style/doctocat" mdxType="ExternalLink">Click here to learn more</ExternalLink>
    <h3>{`Components`}</h3>
    <p>{`Primer Components are useful implementations of the Primer CSS library, implemented as ReactJS Components.`}</p>
    <ExternalLink href="https://primer.style/components" mdxType="ExternalLink">Click here to learn more</ExternalLink>
    <h3>{`StyledOcticons`}</h3>
    <p>{`Primer StyledOcticons are ReactJs Components that are wrapped with system props from the `}<ExternalLink href="https://styled-system.com" mdxType="ExternalLink">{`styled-system`}</ExternalLink>{` package.`}</p>
    <p>{`Not only are these easy to style, but the base package, `}<inlineCode parentName="p">{`@primer/octicons-react`}</inlineCode>{` supports tree-shaking to ensure only used components are bundled.`}</p>
    <ExternalLink href="https://primer.style/octicons" mdxType="ExternalLink">Click here to learn more</ExternalLink>
    <h2>{`MDX`}</h2>
    <Box mb={2} mdxType="Box">
      <Blockquote cite="https://www.gatsbyjs.org/docs/mdx/" css="margin-bottom: 0" mdxType="Blockquote">MDX is Markdown for the component era. It lets you write JSX embedded inside Markdown.
It's a great combination because it allows you to use Markdown's terse syntax (such as `# Heading`) for your content and JSX for more advanced, or reusable components.
      </Blockquote>
      <ExternalLink ml={3} href="https://www.gatsbyjs.org/docs/mdx/" mdxType="ExternalLink">Adding Components to Markdown with MDX | GatsbyJS</ExternalLink>
    </Box>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      